module.exports = __webpack_public_path__ + "img/collectTrue.825f764a.png";